export default __webpack_public_path__ + "static/media/Duct.f135e0dc.png";